import AppHeader from "../../component/modules/appHeader/AppHeader";
import ContactSection from "../../component/modules/contactSection/ContactSection";
import Footer from "../../component/modules/footer/Footer";
import HeroSection from "../../component/modules/heroSection/HeroSection";
import "./index.css";

const Contact = () => {
  return (
    <div className="contact_page_container">
      <AppHeader />
      <div className="contact_content_container">
        <HeroSection
          headingpart1="Contact"
          headingpart2="Us"
          description=" Ready to transform your ideas into reality? We'd love to hear about your project and discuss how we can help bring your vision to life."
        />
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
